import { useEffect } from "react";

import type { Vehicle } from "@busbud/int-schemas/udm";

import {
  getFloorFromLevel,
  hasAvailableSeatsForFloor
} from "@app/helpers/udm/vehicle";
import { changeFloor } from "@app/modules/seat-selection-first/store";

// on load, if bus has 2 floors and no seats are available in 1st floor, we auto select the second one
const getDefaultVehicleFloor = (vehicle: Vehicle | undefined) => {
  if (vehicle?.layout && vehicle?.layout.length > 1) {
    const first_floor = getFloorFromLevel(vehicle.layout, 1);
    if (first_floor && !hasAvailableSeatsForFloor(first_floor)) {
      return 1;
    }
  }
  return 0;
};

export const useAutoSelectInitialFloor = (vehicle: Vehicle | undefined) => {
  useEffect(() => {
    const default_floor = getDefaultVehicleFloor(vehicle);
    changeFloor(default_floor);
  }, [vehicle?.layout]);
};
